module.exports = __webpack_public_path__ + "img/serve.f1c37be5.png";